import { useQuery } from 'hooks/useCustomQuery';
import { useEffect } from 'react';

import { fetchTRSNodes } from 'API/TRSNodes/fetchTRSNodes';

const useGetTRSNodes = (
    setTableData,
    gridRef,
    colDefs,
    selectedCluster = null,
) => {
    const clusterID = selectedCluster?.id;
    const query = useQuery({
        queryKey: ['TRSNodes', clusterID],
        queryFn: () => fetchTRSNodes(clusterID),
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
        enabled: !!clusterID,
    });

    // Handle data updates using useEffect instead of deprecated onSuccess
    useEffect(() => {
        if (query.data) {
            const newData = query.data.map((item) => ({
                ...item,
                clusterName: selectedCluster?.name,
            }));
            setTableData({
                columns: colDefs,
                data: newData,
            });

            // Apply default sorting when data is available
            gridRef?.current?.api?.applyColumnState({
                state: [{ colId: 'name', sort: 'asc' }],
            });
        }
    }, [query.data, setTableData, colDefs, gridRef, selectedCluster]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetTRSNodes;
